import React from "react";
import "./Careers.css";

export default function Careers() {
  return (
    <iframe src="https://darwins.breezy.hr/" title="Darwins Breezy HR"></iframe>
  );
}
